// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function currencyValue(value, currency) {
  return {
    NAME: "currency",
    VAL: [value, currency]
  };
}
function percentValue(value) {
  return {
    NAME: "percent",
    VAL: value
  };
}
function decimalValue(value) {
  return {
    NAME: "decimal",
    VAL: value
  };
}
function integerValue(value) {
  return {
    NAME: "integer",
    VAL: value
  };
}
function styleProps(variant) {
  return {
    0: {
      className: "color-xbp64b2 font-x1ajfx7y",
      "data-style-src": "wino-gc:src/resources/data-visualizations/ValueIndicator.res.js:9"
    },
    1: {
      className: "color-xbp64b2 font-x36xucc",
      "data-style-src": "wino-gc:src/resources/data-visualizations/ValueIndicator.res.js:13"
    }
  }[!!(variant === "compact") << 0];
}
function formatValue(value) {
  let variant = value.NAME;
  if (variant === "percent") {
    return I18n.percentFormat(undefined, 2, 2, value.VAL);
  }
  if (variant === "integer") {
    return I18n.decimalFormat(undefined, 0, 0, undefined, value.VAL);
  }
  if (variant !== "currency") {
    return I18n.decimalFormat(undefined, 2, 2, undefined, value.VAL);
  }
  let match = value.VAL;
  return I18n.currencyFormat(undefined, match[1], 2, 2, match[0]);
}
function ValueIndicator(props) {
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "standard";
  let formattedValue = formatValue(props.value);
  let newrecord = {
    ...styleProps(variant)
  };
  return JsxRuntime.jsx("span", (newrecord.children = formattedValue, newrecord));
}
let make = React.memo(ValueIndicator);
make.displayName = "ValueIndicator";
export { currencyValue, percentValue, decimalValue, integerValue, make };
/* styles Not a pure module */